import produce from 'immer'
import merge from 'lodash/merge'

import { UPDATE_INTL } from '../actions/intl'

const initState = {
  locale: '',
  messages: {},
  formats: {}
}

const intlReducer = produce((draft, action) => {
  switch (action.type) {
    case UPDATE_INTL:
      merge(draft, action.payload)
      return

    default:
      return
  }
}, initState)

export default intlReducer
